import { computed, Ref, ref } from 'vue';
import {
    ClimateEmissionCollection,
    CoverMaterial,
    Specifications,
    Certificate,
} from '@/types/productServerApi';

const productIdData: Ref<string> = ref({} as string);
const variantIdData: Ref<string> = ref({} as string);
const specificationsData: Ref<Specifications | undefined> = ref({} as Specifications);
const coverMaterialData: Ref<CoverMaterial | undefined> = ref({} as CoverMaterial);
const climateEmissionCollectionData: Ref<ClimateEmissionCollection | undefined> = ref({} as ClimateEmissionCollection);

export default function useProductSpecificationData() {
    const setSpecificationData = (productId: string, variantId : string, specifications: Specifications | undefined, coverMaterial: CoverMaterial | undefined, climateEmissionCollection: ClimateEmissionCollection | undefined) => {
        productIdData.value = productId;
        variantIdData.value = variantId;
        specificationsData.value = specifications;
        coverMaterialData.value = coverMaterial;
        climateEmissionCollectionData.value = climateEmissionCollection;
    };

    const productId = computed<string>(() => productIdData.value ?? '');
    const variantId = computed<string>(() => variantIdData.value ?? '');
    const specifications = computed<Specifications | undefined>(() => specificationsData.value);
    const coverMaterial = computed<CoverMaterial | undefined>(() => coverMaterialData.value);
    const climateEmissionsCollection = computed<ClimateEmissionCollection | undefined>(() => climateEmissionCollectionData.value);
    const productCertificationPrimary = computed<Certificate | undefined>(() => {
        return specificationsData.value?.certificates?.find((certification) => certification && certification.imageUrl);
    });

    return {
        setSpecificationData,
        productId,
        variantId,
        productCertificationPrimary,
        coverMaterial,
        specifications,
        climateEmissionsCollection,
    };
}
